import React, { useState, useEffect } from 'react';
import { loadTicketSummary } from "../../api/ticketsApi";
import DateRange from '../../components/DateRange';
import { getFirstDayOfMonth, getLastDayOfMonth } from '../../helper/DateHelper';

const TicketSummary = () => {
  const [ticketSummary, setTicketSummary] = useState([]);
  const [loading, setLoading] = useState(true);
  const initialDateRange = [
    {
      startDate: new Date(getFirstDayOfMonth()),
      endDate: new Date(getLastDayOfMonth()),
      key: 'selection'
    }
  ];
  const [dateRange, setDateRange] = useState(initialDateRange);


  const fetchTicketSummary = async (startDate, endDate) => {
    try {
      setLoading(true);
      const response = await loadTicketSummary(startDate, endDate);
      if (response.status === 200) {
        setTicketSummary(response.data);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleDateRangeChange = (newRange) => {
    setDateRange(newRange);
    fetchTicketSummary(newRange[0].startDate, newRange[0].endDate);
  };

  useEffect(() => {
    const handlePageLoad = () => {
      fetchTicketSummary(dateRange.startDate, dateRange.endDate);
    };
    if (document.readyState === "complete") {
      handlePageLoad();
    } else {
      window.addEventListener("load", handlePageLoad);
    }

    window.addEventListener("load", handlePageLoad);
    return () => {
      window.removeEventListener("load", handlePageLoad);
    };
  }, []);
  const renderSections = (sectionName, sectionData) => {
    const itemsPerSection = 6;
    const sections = [];
    for (let i = 0; i < sectionData.length; i += itemsPerSection) {
      sections.push(sectionData.slice(i, i + itemsPerSection));
    }

    return sections.map((chunk, idx) => {
      const gridCols = chunk.length < 3 ? `grid-cols-${chunk.length}` : 'grid-cols-3';
      return (
        <section key={idx} className={`grid ${gridCols} gap-6 mb-6`}>
          <h2 className="col-span-full text-lg font-semibold text-gray-400">{sectionName}</h2>
          {chunk.map((item, idx) => (
            <div key={idx} className="bg-white shadow-md p-4 rounded-lg flex justify-between items-center border border-blue-400 rounded-full">
              <div className="flex-grow text-left">
                <h3 className="text-gray-500 text-lg font-semibold">{item.name} Tickets</h3>
                <p className="text-4xl font-bold text-blue-500">
                  {loading ? "Loading..." : item.value}
                </p>
              </div>
              <div className="text-right">
                <p className="text-4xl font-bold text-blue-500">
                  {loading ? "Loading..." : item.key}
                </p>
              </div>
            </div>
          ))}
        </section>
      );
    });
  };

  return (
    <div>
      {/* <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        <DateRange
          dateRange={dateRange}
          setDateRange={handleDateRangeChange}
          label="Filter Tickets by Date"
        />
      </div> */}
      <section className="mb-6">
        <section className="mb-6">
          {/* Priority Section */}
          {loading ? (
            <div>Loading...</div>
          ) : (
            ticketSummary
              .filter((section) => section.name === "Priority")
              .map((section, index) => (
                <React.Fragment key={index}>
                  {renderSections("By Priority", section.object)}
                </React.Fragment>
              ))
          )}

          {/* Progress Status Section */}
          {loading ? (
            <div>Loading...</div>
          ) : (
            ticketSummary
              .filter((section) => section.name === "ProgressStatus") // Filter only ProgressStatus data
              .map((section, index) => (
                <React.Fragment key={index}>
                  {renderSections("By Progress", section.object)}
                </React.Fragment>
              ))
          )}
        </section>
      </section>
    </div>
  );
};

export default TicketSummary;
